import { render, staticRenderFns } from "./Toutiao.vue?vue&type=template&id=58b2f334&scoped=true&"
import script from "./Toutiao.vue?vue&type=script&lang=js&"
export * from "./Toutiao.vue?vue&type=script&lang=js&"
import style0 from "./Toutiao.vue?vue&type=style&index=0&id=58b2f334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b2f334",
  null
  
)

export default component.exports